import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Img from 'gatsby-image';
import './Card.scss';

export default class Card extends Component {
  static propTypes = {
    animation: PropTypes.oneOf(['fade', 'translate']),
    cover: PropTypes.object,
    color: PropTypes.string,
    textTop: PropTypes.string,
    textBottom: PropTypes.string,
    style: PropTypes.object
  };

  static defaultProps = {
    animation: 'fade',
    cover: null,
    color: 'rgba(0, 0, 0, 0.5)',
    textTop: null,
    textBottom: null,
    style: null
  };

  constructor() {
    super();
    this.card = React.createRef();
    this.state = { maskDirection: null };
  }

  componentDidMount() {
    this.card.current.addEventListener('mouseenter', this.onMouseEnter);
    this.card.current.addEventListener('mouseleave', this.onMouseLeave);
  }

  componentWillUnmount() {
    this.card.current.removeEventListener('mouseenter', this.onMouseEnter);
    this.card.current.removeEventListener('mouseleave', this.onMouseLeave);
  }

  onMouseEnter = e => {
    const direction = this.closestEdge(e, this.card.current);
    this.setState({ maskDirection: `in-${direction}` });
  };

  onMouseLeave = e => {
    const direction = this.closestEdge(e, this.card.current);
    this.setState({ maskDirection: `out-${direction}` });
  };

  // getDirectionKey = (e, node) => {
  //   const { width, height, top, left } = node.getBoundingClientRect();
  //   const l = e.offsetX - left - window.pageXOffset;
  //   const t = e.offsetY - top - window.pageYOffset;
  //   const x = l - (width / 2) * (width > height ? height / width : 1);
  //   const y = t - (height / 2) * (height > width ? width / height : 1);
  //   return Math.round(Math.atan2(y, x) / 1.57079633 + 5) % 4;
  // };

  closestEdge = (e, node) => {
    const x = e.offsetX;
    const y = e.offsetY;
    const w = node.offsetWidth;
    const h = node.offsetHeight;
    const topEdgeDist = this.distMetric(x, y, w / 2, 0);
    const bottomEdgeDist = this.distMetric(x, y, w / 2, h);
    const leftEdgeDist = this.distMetric(x, y, 0, h / 2);
    const rightEdgeDist = this.distMetric(x, y, w, h / 2);
    const min = Math.min(topEdgeDist, bottomEdgeDist, leftEdgeDist, rightEdgeDist);
    switch (min) {
      case topEdgeDist:
        return 'top';
      case bottomEdgeDist:
        return 'bottom';
      case leftEdgeDist:
        return 'left';
      case rightEdgeDist:
        return 'right';
      default:
        return 'top;';
    }
  };

  distMetric = (x, y, x2, y2) => {
    const xDiff = x - x2;
    const yDiff = y - y2;
    return xDiff * xDiff + yDiff * yDiff;
  };

  render() {
    const { animation, cover, color, textTop, textBottom, style } = this.props;
    const { maskDirection } = this.state;
    return (
      <div ref={this.card} className="card" style={style}>
        <div className={classNames('card-mask', animation, maskDirection)} style={{ background: color }} />
        <div className="card-cover">
          <Img sizes={cover.childImageSharp.sizes} />
        </div>
        <div className="card-text">
          {textTop && (
            <div className="wrapper">
              <div className="text-top">{textTop}</div>
              <div className="line" />
            </div>
          )}
          {textBottom && <div className="text-bottom">{textBottom}</div>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Card/Card.jsx